/* eslint-disable no-nested-ternary */
import { Icon } from '@components';
import { useScreenSize } from '@hooks';
import { Flex, theme, Typography } from '@styles';
import { ReactComponent as GenevaCallLogo } from '@svgs/geneva-call-logo.svg';
import { enTranlation, uaTranlation } from '@translations';
import { bool, string } from 'prop-types';
import React, { useMemo } from 'react';

import ShadowedCard from '../ShadowedCard/ShadowedCard';
import { getLayoutProps, LogoIcon, styles } from './Certificate.layoutProps';

const Certificate = ({
  date,
  isPDFGenerationVariant,
  language,
  name,
  size,
  title,
}) => {
  const { isTabletSM } = useScreenSize();
  const text = useMemo(
    () => (language === 'en' ? enTranlation : uaTranlation),
    [language]
  );

  const titleByLevel = {
    'Officer Level': 'OfficerLevel',
    'Soldier Level': 'SoldierLevel',
    'Рівень офіцера': 'OfficerLevel',
    'Рівень солдата': 'SoldierLevel',
  };

  const getTextLayoutProps = getLayoutProps({
    device: isTabletSM && !isPDFGenerationVariant ? 'mobile' : 'desktop',
    size,
  });

  const isMobile = isTabletSM && !isPDFGenerationVariant;

  return (
    <Flex
      {...styles.container}
      px={isMobile ? 30 : 72}
      {...(isPDFGenerationVariant && { width: '1280px' })}
      py={isMobile ? 30 : 75}
    >
      <Flex {...styles.certificateContainer}>
        <Flex
          height={isMobile ? '200px' : '712px'}
          {...styles.backgroundImage}
        />
        <ShadowedCard
          isMobile={isMobile}
          position="absolute"
          text={text.Certificate.Title}
          top={isMobile ? '-10px' : '-40px'}
          withBottomOffset={isPDFGenerationVariant}
        />
        <Flex {...styles.contentContainer}>
          <Typography textAlign="center" {...getTextLayoutProps('subtitle')}>
            {text.Certificate.Subtitle}
          </Typography>
          <Typography textAlign="center" {...getTextLayoutProps('name')}>
            {name || text.Certificate.Name}
          </Typography>
          <Typography
            mt={isMobile ? '12px' : '47px'}
            textAlign="center"
            {...getTextLayoutProps('default')}
          >
            {text.Certificate.For}
          </Typography>
          <Typography textAlign="center" {...getTextLayoutProps('bold')}>
            {text.Certificate[titleByLevel[title] || title]?.toUpperCase() ||
              title.toUpperCase()}
            <br />
            {text.Certificate.OfPlatformCourse}
          </Typography>
          <Typography
            color={
              isPDFGenerationVariant ? theme.colors.tundora : theme.colors.gray
            }
            textAlign="center"
            {...getTextLayoutProps('default')}
          >
            {date}
          </Typography>
          <Flex
            flexDirection="row"
            gap={10}
            mb={isMobile ? '10px' : '60px'}
            mt="auto"
          >
            <Icon
              height={isMobile ? 25 : 97}
              SVG={GenevaCallLogo}
              width={isMobile ? 25 : 114}
            />
            <Icon
              fill="#333"
              height={isMobile ? 25 : 97}
              SVG={LogoIcon[language || 'en']}
              width={isMobile ? 25 : 114}
            />
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
};

Certificate.propTypes = {
  date: string,
  isPDFGenerationVariant: bool,
  language: string,
  name: string,
  size: string,
  title: string,
};

Certificate.defaultProps = {
  date: '**/**/****',
  isPDFGenerationVariant: false,
  language: 'en',
  name: null,
  size: 'big',
  title: '...',
};

export default Certificate;
